import React from 'react';
import '../assets/css/About.css';

function About() {
  return (
    <section id="about" className="about">
      <div className="container">
        <h2>About Meconsteel88 Co</h2>
        <div className="about-content">
          <div className="about-text">
            <p>
              With over 35 years of experience in the construction and steel fabrication industry, 
              Meconsteel88 Co has established itself as a leader in delivering quality construction 
              solutions across the Philippines.
            </p>
            <p>
              We specialize in structural steel design, fabrication, and installation for residential, 
              commercial, and industrial projects. Our team of experienced engineers and skilled workers 
              are committed to delivering projects on time and within budget while maintaining the highest 
              standards of safety and quality.
            </p>
            {/* Removed about-stats cards as requested */}
            <div className="about-mission-vision">
              <div className="mission-vision-card mission">
                <h3>OUR MISSION</h3>
                <p className="mission-text highlight-text">
                  TO TRANSFORM VISIONS INTO REALITY THROUGH OUR WORKS AND TO BUILD NOT JUST STRUCTURES BUT ENDURING RELATIONSHIPS WITH OUR CLIENTS, PARTNERS, AND COMMUNITIES
                </p>
              </div>
              <div className="mission-vision-card vision">
                <h3>OUR VISION</h3>
                <p className="vision-text highlight-text">
                  BUILDING HOMES AND DREAMS, CREATING SPACES AND ENRICHING LIVES
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
